// Globals
import { useTranslation } from 'react-i18next';

// Components
import { ConfirmationModal } from '@/components';

interface ILogoutConfirmationModal {
  isOpened: boolean;
  onClose: () => void;
  onLogout: () => void;
}

const LogoutConfirmationModal = ({ onLogout, isOpened, onClose }: ILogoutConfirmationModal) => {
  const { t } = useTranslation(['auth']);

  return (
    <ConfirmationModal
      isOpened={isOpened}
      content={t('auth_logout_description')}
      onCancel={onClose}
      onConfirm={onLogout}
      title={t('auth_logout_title')}
      cancelText={t('auth_logout_stay')}
      okText={t('auth_logout_confirm')}
    />
  );
};

export default LogoutConfirmationModal;
